// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as MarrakechCarouselRouteImport } from './routes/marrakech-carousel'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DakhlaCarouselRouteImport } from './routes/dakhla-carousel'
import { Route as ConceptRouteImport } from './routes/concept'
import { Route as CarouselRouteImport } from './routes/carousel'
import { Route as AgafayTarifsRouteImport } from './routes/agafay-tarifs'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangSignInRouteImport } from './routes/$lang/sign-in'
import { Route as LangLoginRouteImport } from './routes/$lang/login'
import { Route as LangPartnerRouteImport } from './routes/$lang/_partner'
import { Route as LangLayoutRouteImport } from './routes/$lang/_layout'
import { Route as AuthedAccountRouteImport } from './routes/_authed/account'
import { Route as LangPartnerPartnerRouteImport } from './routes/$lang/_partner/partner'
import { Route as LangLayoutIndexRouteImport } from './routes/$lang/_layout/index'
import { Route as LangLayoutWomenRouteImport } from './routes/$lang/_layout/women'
import { Route as LangLayoutTripsRouteImport } from './routes/$lang/_layout/trips'
import { Route as LangLayoutTripPlannerRouteImport } from './routes/$lang/_layout/trip-planner'
import { Route as LangLayoutTransportRouteImport } from './routes/$lang/_layout/transport'
import { Route as LangLayoutTermsOfServiceRouteImport } from './routes/$lang/_layout/terms-of-service'
import { Route as LangLayoutTermsAndConditionsRouteImport } from './routes/$lang/_layout/terms-and-conditions'
import { Route as LangLayoutReelsRouteImport } from './routes/$lang/_layout/reels'
import { Route as LangLayoutPrivacyPolicyRouteImport } from './routes/$lang/_layout/privacy-policy'
import { Route as LangLayoutLikedRouteImport } from './routes/$lang/_layout/liked'
import { Route as LangLayoutFaqRouteImport } from './routes/$lang/_layout/faq'
import { Route as LangLayoutDiscoverRouteImport } from './routes/$lang/_layout/discover'
import { Route as LangLayoutCreatorsRouteImport } from './routes/$lang/_layout/creators'
import { Route as LangLayoutCookiePolicyRouteImport } from './routes/$lang/_layout/cookie-policy'
import { Route as LangLayoutContactRouteImport } from './routes/$lang/_layout/contact'
import { Route as LangLayoutConciergeRouteImport } from './routes/$lang/_layout/concierge'
import { Route as LangLayoutCancellationPolicyRouteImport } from './routes/$lang/_layout/cancellation-policy'
import { Route as LangLayoutBucketRouteImport } from './routes/$lang/_layout/bucket'
import { Route as LangLayoutBlogRouteImport } from './routes/$lang/_layout/blog'
import { Route as LangLayoutBecomeAPartnerRouteImport } from './routes/$lang/_layout/become-a-partner'
import { Route as LangLayoutAmbassadorsRouteImport } from './routes/$lang/_layout/ambassadors'
import { Route as LangLayoutAiTravelPlannerRouteImport } from './routes/$lang/_layout/ai-travel-planner'
import { Route as LangLayoutAiChatRouteImport } from './routes/$lang/_layout/ai-chat'
import { Route as LangLayoutAboutRouteImport } from './routes/$lang/_layout/about'
import { Route as LangLayout504RouteImport } from './routes/$lang/_layout/504'
import { Route as LangLayout503RouteImport } from './routes/$lang/_layout/503'
import { Route as LangLayout502RouteImport } from './routes/$lang/_layout/502'
import { Route as LangLayout500RouteImport } from './routes/$lang/_layout/500'
import { Route as LangLayout429RouteImport } from './routes/$lang/_layout/429'
import { Route as LangLayout422RouteImport } from './routes/$lang/_layout/422'
import { Route as LangLayout410RouteImport } from './routes/$lang/_layout/410'
import { Route as LangLayout409RouteImport } from './routes/$lang/_layout/409'
import { Route as LangLayout408RouteImport } from './routes/$lang/_layout/408'
import { Route as LangLayout404RouteImport } from './routes/$lang/_layout/404'
import { Route as LangLayout403RouteImport } from './routes/$lang/_layout/403'
import { Route as LangLayout401RouteImport } from './routes/$lang/_layout/401'
import { Route as LangLayout400RouteImport } from './routes/$lang/_layout/400'
import { Route as LangLayoutSlugRouteImport } from './routes/$lang/_layout/$slug'
import { Route as AuthedAccountAmbassadorRouteImport } from './routes/_authed/account_.ambassador'
import { Route as AuthedAccountReservationsRouteImport } from './routes/_authed/account/reservations'
import { Route as LangPartnerPartnerIndexRouteImport } from './routes/$lang/_partner/partner.index'
import { Route as LangPartnerPartnerMoneyRouteImport } from './routes/$lang/_partner/partner.money'
import { Route as LangPartnerPartnerHelpRouteImport } from './routes/$lang/_partner/partner.help'
import { Route as LangPartnerPartnerAccountRouteImport } from './routes/$lang/_partner/partner.account'
import { Route as LangLayoutStaysIndexRouteImport } from './routes/$lang/_layout/stays.index'
import { Route as LangLayoutPlaceIndexRouteImport } from './routes/$lang/_layout/place.index'
import { Route as LangLayoutExploreIndexRouteImport } from './routes/$lang/_layout/explore.index'
import { Route as LangLayoutErrorIndexRouteImport } from './routes/$lang/_layout/error.index'
import { Route as LangLayoutBookingsIndexRouteImport } from './routes/$lang/_layout/bookings.index'
import { Route as LangLayoutTransportSlugRouteImport } from './routes/$lang/_layout/transport_.$slug'
import { Route as LangLayoutStaysCheckoutRouteImport } from './routes/$lang/_layout/stays.checkout'
import { Route as LangLayoutPlaceCityRouteImport } from './routes/$lang/_layout/place.$city'
import { Route as LangLayoutOrganiserSlugRouteImport } from './routes/$lang/_layout/organiser.$slug'
import { Route as LangLayoutErrorStatusRouteImport } from './routes/$lang/_layout/error.$status'
import { Route as LangLayoutCompareBrandRouteImport } from './routes/$lang/_layout/compare.$brand'
import { Route as LangLayoutChatTokenRouteImport } from './routes/$lang/_layout/chat.$token'
import { Route as LangLayoutCategoryCategoryRouteImport } from './routes/$lang/_layout/category.$category'
import { Route as LangLayoutAHandleRouteImport } from './routes/$lang/_layout/a.$handle'
import { Route as LangLayoutBucketIndexRouteImport } from './routes/$lang/_layout/bucket.index'
import { Route as LangLayoutBucketCheckoutRouteImport } from './routes/$lang/_layout/bucket.checkout'
import { Route as LangLayoutBlogIndexRouteImport } from './routes/$lang/_layout/blog.index'
import { Route as LangLayoutBlogSlugRouteImport } from './routes/$lang/_layout/blog.$slug'
import { Route as LangLayoutSlugIndexRouteImport } from './routes/$lang/_layout/$slug.index'
import { Route as LangLayoutSlugPackagesRouteImport } from './routes/$lang/_layout/$slug.packages'
import { Route as LangLayoutSlugDetailsRouteImport } from './routes/$lang/_layout/$slug.details'
import { Route as LangLayoutSlugCheckoutRouteImport } from './routes/$lang/_layout/$slug.checkout'
import { Route as LangLayoutStaysCityIndexRouteImport } from './routes/$lang/_layout/stays.$city.index'
import { Route as LangLayoutExploreCityIndexRouteImport } from './routes/$lang/_layout/explore.$city.index'
import { Route as LangLayoutCatSlugIndexRouteImport } from './routes/$lang/_layout/$cat.$slug.index'
import { Route as LangLayoutStaysReceiptReferenceRouteImport } from './routes/$lang/_layout/stays.receipt.$reference'
import { Route as LangLayoutStaysConfirmationReferenceRouteImport } from './routes/$lang/_layout/stays.confirmation.$reference'
import { Route as LangLayoutStaysBookingReferenceRouteImport } from './routes/$lang/_layout/stays.booking.$reference'
import { Route as LangLayoutExploreCitySlugRouteImport } from './routes/$lang/_layout/explore.$city.$slug'
import { Route as LangLayoutBookingBookingIdThankYouRouteImport } from './routes/$lang/_layout/booking.$bookingId.thank-you'
import { Route as LangLayoutCityCategorySlugRouteImport } from './routes/$lang/_layout/$city.$category.$slug'
import { Route as LangLayoutCategoryCategoryCityRouteImport } from './routes/$lang/_layout/category.$category.$city'
import { Route as LangPartnerPartnerTripsActivityIdSettingsRouteImport } from './routes/$lang/_partner/partner.trips.$activityId.settings'
import { Route as LangLayoutStaysCitySlugIndexRouteImport } from './routes/$lang/_layout/stays.$city.$slug.index'
import { Route as LangLayoutCityCategorySlugIndexRouteImport } from './routes/$lang/_layout/$city.$category.$slug.index'
import { Route as LangLayoutCityCategorySlugPackagesRouteImport } from './routes/$lang/_layout/$city.$category.$slug.packages'
import { Route as LangPartnerPartnerTripsActivityIdDatesDateRouteImport } from './routes/$lang/_partner/partner.trips.$activityId.dates.$date'

const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const MarrakechCarouselRoute = MarrakechCarouselRouteImport.update({
            id: '/marrakech-carousel',path: '/marrakech-carousel',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DakhlaCarouselRoute = DakhlaCarouselRouteImport.update({
            id: '/dakhla-carousel',path: '/dakhla-carousel',getParentRoute: () => rootRouteImport
          })
const ConceptRoute = ConceptRouteImport.update({
            id: '/concept',path: '/concept',getParentRoute: () => rootRouteImport
          })
const CarouselRoute = CarouselRouteImport.update({
            id: '/carousel',path: '/carousel',getParentRoute: () => rootRouteImport
          })
const AgafayTarifsRoute = AgafayTarifsRouteImport.update({
            id: '/agafay-tarifs',path: '/agafay-tarifs',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangSignInRoute = LangSignInRouteImport.update({
            id: '/$lang/sign-in',path: '/$lang/sign-in',getParentRoute: () => rootRouteImport
          })
const LangLoginRoute = LangLoginRouteImport.update({
            id: '/$lang/login',path: '/$lang/login',getParentRoute: () => rootRouteImport
          })
const LangPartnerRoute = LangPartnerRouteImport.update({
            id: '/$lang/_partner',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const LangLayoutRoute = LangLayoutRouteImport.update({
            id: '/$lang/_layout',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const AuthedAccountRoute = AuthedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthedRoute
          })
const LangPartnerPartnerRoute = LangPartnerPartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => LangPartnerRoute
          })
const LangLayoutIndexRoute = LangLayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutWomenRoute = LangLayoutWomenRouteImport.update({
            id: '/women',path: '/women',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutTripsRoute = LangLayoutTripsRouteImport.update({
            id: '/trips',path: '/trips',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutTripPlannerRoute = LangLayoutTripPlannerRouteImport.update({
            id: '/trip-planner',path: '/trip-planner',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutTransportRoute = LangLayoutTransportRouteImport.update({
            id: '/transport',path: '/transport',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutTermsOfServiceRoute = LangLayoutTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutTermsAndConditionsRoute = LangLayoutTermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutReelsRoute = LangLayoutReelsRouteImport.update({
            id: '/reels',path: '/reels',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutPrivacyPolicyRoute = LangLayoutPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutLikedRoute = LangLayoutLikedRouteImport.update({
            id: '/liked',path: '/liked',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutFaqRoute = LangLayoutFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutDiscoverRoute = LangLayoutDiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCreatorsRoute = LangLayoutCreatorsRouteImport.update({
            id: '/creators',path: '/creators',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCookiePolicyRoute = LangLayoutCookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutContactRoute = LangLayoutContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutConciergeRoute = LangLayoutConciergeRouteImport.update({
            id: '/concierge',path: '/concierge',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCancellationPolicyRoute = LangLayoutCancellationPolicyRouteImport.update({
            id: '/cancellation-policy',path: '/cancellation-policy',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBucketRoute = LangLayoutBucketRouteImport.update({
            id: '/bucket',path: '/bucket',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBlogRoute = LangLayoutBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBecomeAPartnerRoute = LangLayoutBecomeAPartnerRouteImport.update({
            id: '/become-a-partner',path: '/become-a-partner',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutAmbassadorsRoute = LangLayoutAmbassadorsRouteImport.update({
            id: '/ambassadors',path: '/ambassadors',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutAiTravelPlannerRoute = LangLayoutAiTravelPlannerRouteImport.update({
            id: '/ai-travel-planner',path: '/ai-travel-planner',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutAiChatRoute = LangLayoutAiChatRouteImport.update({
            id: '/ai-chat',path: '/ai-chat',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutAboutRoute = LangLayoutAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LangLayoutRoute
          })
const LangLayout504Route = LangLayout504RouteImport.update({
            id: '/504',path: '/504',getParentRoute: () => LangLayoutRoute
          })
const LangLayout503Route = LangLayout503RouteImport.update({
            id: '/503',path: '/503',getParentRoute: () => LangLayoutRoute
          })
const LangLayout502Route = LangLayout502RouteImport.update({
            id: '/502',path: '/502',getParentRoute: () => LangLayoutRoute
          })
const LangLayout500Route = LangLayout500RouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => LangLayoutRoute
          })
const LangLayout429Route = LangLayout429RouteImport.update({
            id: '/429',path: '/429',getParentRoute: () => LangLayoutRoute
          })
const LangLayout422Route = LangLayout422RouteImport.update({
            id: '/422',path: '/422',getParentRoute: () => LangLayoutRoute
          })
const LangLayout410Route = LangLayout410RouteImport.update({
            id: '/410',path: '/410',getParentRoute: () => LangLayoutRoute
          })
const LangLayout409Route = LangLayout409RouteImport.update({
            id: '/409',path: '/409',getParentRoute: () => LangLayoutRoute
          })
const LangLayout408Route = LangLayout408RouteImport.update({
            id: '/408',path: '/408',getParentRoute: () => LangLayoutRoute
          })
const LangLayout404Route = LangLayout404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => LangLayoutRoute
          })
const LangLayout403Route = LangLayout403RouteImport.update({
            id: '/403',path: '/403',getParentRoute: () => LangLayoutRoute
          })
const LangLayout401Route = LangLayout401RouteImport.update({
            id: '/401',path: '/401',getParentRoute: () => LangLayoutRoute
          })
const LangLayout400Route = LangLayout400RouteImport.update({
            id: '/400',path: '/400',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutSlugRoute = LangLayoutSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LangLayoutRoute
          })
const AuthedAccountAmbassadorRoute = AuthedAccountAmbassadorRouteImport.update({
            id: '/account_/ambassador',path: '/account/ambassador',getParentRoute: () => AuthedRoute
          })
const AuthedAccountReservationsRoute = AuthedAccountReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => AuthedAccountRoute
          })
const LangPartnerPartnerIndexRoute = LangPartnerPartnerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangPartnerPartnerRoute
          })
const LangPartnerPartnerMoneyRoute = LangPartnerPartnerMoneyRouteImport.update({
            id: '/money',path: '/money',getParentRoute: () => LangPartnerPartnerRoute
          })
const LangPartnerPartnerHelpRoute = LangPartnerPartnerHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => LangPartnerPartnerRoute
          })
const LangPartnerPartnerAccountRoute = LangPartnerPartnerAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => LangPartnerPartnerRoute
          })
const LangLayoutStaysIndexRoute = LangLayoutStaysIndexRouteImport.update({
            id: '/stays/',path: '/stays/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutPlaceIndexRoute = LangLayoutPlaceIndexRouteImport.update({
            id: '/place/',path: '/place/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutExploreIndexRoute = LangLayoutExploreIndexRouteImport.update({
            id: '/explore/',path: '/explore/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutErrorIndexRoute = LangLayoutErrorIndexRouteImport.update({
            id: '/error/',path: '/error/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBookingsIndexRoute = LangLayoutBookingsIndexRouteImport.update({
            id: '/bookings/',path: '/bookings/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutTransportSlugRoute = LangLayoutTransportSlugRouteImport.update({
            id: '/transport_/$slug',path: '/transport/$slug',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutStaysCheckoutRoute = LangLayoutStaysCheckoutRouteImport.update({
            id: '/stays/checkout',path: '/stays/checkout',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutPlaceCityRoute = LangLayoutPlaceCityRouteImport.update({
            id: '/place/$city',path: '/place/$city',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutOrganiserSlugRoute = LangLayoutOrganiserSlugRouteImport.update({
            id: '/organiser/$slug',path: '/organiser/$slug',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutErrorStatusRoute = LangLayoutErrorStatusRouteImport.update({
            id: '/error/$status',path: '/error/$status',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCompareBrandRoute = LangLayoutCompareBrandRouteImport.update({
            id: '/compare/$brand',path: '/compare/$brand',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutChatTokenRoute = LangLayoutChatTokenRouteImport.update({
            id: '/chat/$token',path: '/chat/$token',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCategoryCategoryRoute = LangLayoutCategoryCategoryRouteImport.update({
            id: '/category/$category',path: '/category/$category',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutAHandleRoute = LangLayoutAHandleRouteImport.update({
            id: '/a/$handle',path: '/a/$handle',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBucketIndexRoute = LangLayoutBucketIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangLayoutBucketRoute
          })
const LangLayoutBucketCheckoutRoute = LangLayoutBucketCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => LangLayoutBucketRoute
          })
const LangLayoutBlogIndexRoute = LangLayoutBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangLayoutBlogRoute
          })
const LangLayoutBlogSlugRoute = LangLayoutBlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LangLayoutBlogRoute
          })
const LangLayoutSlugIndexRoute = LangLayoutSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangLayoutSlugRoute
          })
const LangLayoutSlugPackagesRoute = LangLayoutSlugPackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => LangLayoutSlugRoute
          })
const LangLayoutSlugDetailsRoute = LangLayoutSlugDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => LangLayoutSlugRoute
          })
const LangLayoutSlugCheckoutRoute = LangLayoutSlugCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => LangLayoutSlugRoute
          })
const LangLayoutStaysCityIndexRoute = LangLayoutStaysCityIndexRouteImport.update({
            id: '/stays/$city/',path: '/stays/$city/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutExploreCityIndexRoute = LangLayoutExploreCityIndexRouteImport.update({
            id: '/explore/$city/',path: '/explore/$city/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCatSlugIndexRoute = LangLayoutCatSlugIndexRouteImport.update({
            id: '/$cat/$slug/',path: '/$cat/$slug/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutStaysReceiptReferenceRoute = LangLayoutStaysReceiptReferenceRouteImport.update({
            id: '/stays/receipt/$reference',path: '/stays/receipt/$reference',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutStaysConfirmationReferenceRoute = LangLayoutStaysConfirmationReferenceRouteImport.update({
            id: '/stays/confirmation/$reference',path: '/stays/confirmation/$reference',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutStaysBookingReferenceRoute = LangLayoutStaysBookingReferenceRouteImport.update({
            id: '/stays/booking/$reference',path: '/stays/booking/$reference',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutExploreCitySlugRoute = LangLayoutExploreCitySlugRouteImport.update({
            id: '/explore/$city/$slug',path: '/explore/$city/$slug',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutBookingBookingIdThankYouRoute = LangLayoutBookingBookingIdThankYouRouteImport.update({
            id: '/booking/$bookingId/thank-you',path: '/booking/$bookingId/thank-you',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCityCategorySlugRoute = LangLayoutCityCategorySlugRouteImport.update({
            id: '/$city/$category/$slug',path: '/$city/$category/$slug',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCategoryCategoryCityRoute = LangLayoutCategoryCategoryCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => LangLayoutCategoryCategoryRoute
          })
const LangPartnerPartnerTripsActivityIdSettingsRoute = LangPartnerPartnerTripsActivityIdSettingsRouteImport.update({
            id: '/trips/$activityId/settings',path: '/trips/$activityId/settings',getParentRoute: () => LangPartnerPartnerRoute
          })
const LangLayoutStaysCitySlugIndexRoute = LangLayoutStaysCitySlugIndexRouteImport.update({
            id: '/stays/$city/$slug/',path: '/stays/$city/$slug/',getParentRoute: () => LangLayoutRoute
          })
const LangLayoutCityCategorySlugIndexRoute = LangLayoutCityCategorySlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangLayoutCityCategorySlugRoute
          })
const LangLayoutCityCategorySlugPackagesRoute = LangLayoutCityCategorySlugPackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => LangLayoutCityCategorySlugRoute
          })
const LangPartnerPartnerTripsActivityIdDatesDateRoute = LangPartnerPartnerTripsActivityIdDatesDateRouteImport.update({
            id: '/trips/$activityId/dates/$date',path: '/trips/$activityId/dates/$date',getParentRoute: () => LangPartnerPartnerRoute
          })





const AuthedAccountRouteChildren = {
  AuthedAccountReservationsRoute: AuthedAccountReservationsRoute
}

const AuthedAccountRouteWithChildren = AuthedAccountRoute._addFileChildren(AuthedAccountRouteChildren)



const AuthedRouteChildren = {
  AuthedAccountRoute: AuthedAccountRouteWithChildren,AuthedAccountAmbassadorRoute: AuthedAccountAmbassadorRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)




const LangLayoutSlugRouteChildren = {
  LangLayoutSlugCheckoutRoute: LangLayoutSlugCheckoutRoute,LangLayoutSlugDetailsRoute: LangLayoutSlugDetailsRoute,LangLayoutSlugPackagesRoute: LangLayoutSlugPackagesRoute,LangLayoutSlugIndexRoute: LangLayoutSlugIndexRoute
}

const LangLayoutSlugRouteWithChildren = LangLayoutSlugRoute._addFileChildren(LangLayoutSlugRouteChildren)




const LangLayoutBlogRouteChildren = {
  LangLayoutBlogSlugRoute: LangLayoutBlogSlugRoute,LangLayoutBlogIndexRoute: LangLayoutBlogIndexRoute
}

const LangLayoutBlogRouteWithChildren = LangLayoutBlogRoute._addFileChildren(LangLayoutBlogRouteChildren)




const LangLayoutBucketRouteChildren = {
  LangLayoutBucketCheckoutRoute: LangLayoutBucketCheckoutRoute,LangLayoutBucketIndexRoute: LangLayoutBucketIndexRoute
}

const LangLayoutBucketRouteWithChildren = LangLayoutBucketRoute._addFileChildren(LangLayoutBucketRouteChildren)




const LangLayoutCategoryCategoryRouteChildren = {
  LangLayoutCategoryCategoryCityRoute: LangLayoutCategoryCategoryCityRoute
}

const LangLayoutCategoryCategoryRouteWithChildren = LangLayoutCategoryCategoryRoute._addFileChildren(LangLayoutCategoryCategoryRouteChildren)




const LangLayoutCityCategorySlugRouteChildren = {
  LangLayoutCityCategorySlugPackagesRoute: LangLayoutCityCategorySlugPackagesRoute,LangLayoutCityCategorySlugIndexRoute: LangLayoutCityCategorySlugIndexRoute
}

const LangLayoutCityCategorySlugRouteWithChildren = LangLayoutCityCategorySlugRoute._addFileChildren(LangLayoutCityCategorySlugRouteChildren)



const LangLayoutRouteChildren = {
  LangLayoutSlugRoute: LangLayoutSlugRouteWithChildren,LangLayout400Route: LangLayout400Route,LangLayout401Route: LangLayout401Route,LangLayout403Route: LangLayout403Route,LangLayout404Route: LangLayout404Route,LangLayout408Route: LangLayout408Route,LangLayout409Route: LangLayout409Route,LangLayout410Route: LangLayout410Route,LangLayout422Route: LangLayout422Route,LangLayout429Route: LangLayout429Route,LangLayout500Route: LangLayout500Route,LangLayout502Route: LangLayout502Route,LangLayout503Route: LangLayout503Route,LangLayout504Route: LangLayout504Route,LangLayoutAboutRoute: LangLayoutAboutRoute,LangLayoutAiChatRoute: LangLayoutAiChatRoute,LangLayoutAiTravelPlannerRoute: LangLayoutAiTravelPlannerRoute,LangLayoutAmbassadorsRoute: LangLayoutAmbassadorsRoute,LangLayoutBecomeAPartnerRoute: LangLayoutBecomeAPartnerRoute,LangLayoutBlogRoute: LangLayoutBlogRouteWithChildren,LangLayoutBucketRoute: LangLayoutBucketRouteWithChildren,LangLayoutCancellationPolicyRoute: LangLayoutCancellationPolicyRoute,LangLayoutConciergeRoute: LangLayoutConciergeRoute,LangLayoutContactRoute: LangLayoutContactRoute,LangLayoutCookiePolicyRoute: LangLayoutCookiePolicyRoute,LangLayoutCreatorsRoute: LangLayoutCreatorsRoute,LangLayoutDiscoverRoute: LangLayoutDiscoverRoute,LangLayoutFaqRoute: LangLayoutFaqRoute,LangLayoutLikedRoute: LangLayoutLikedRoute,LangLayoutPrivacyPolicyRoute: LangLayoutPrivacyPolicyRoute,LangLayoutReelsRoute: LangLayoutReelsRoute,LangLayoutTermsAndConditionsRoute: LangLayoutTermsAndConditionsRoute,LangLayoutTermsOfServiceRoute: LangLayoutTermsOfServiceRoute,LangLayoutTransportRoute: LangLayoutTransportRoute,LangLayoutTripPlannerRoute: LangLayoutTripPlannerRoute,LangLayoutTripsRoute: LangLayoutTripsRoute,LangLayoutWomenRoute: LangLayoutWomenRoute,LangLayoutIndexRoute: LangLayoutIndexRoute,LangLayoutAHandleRoute: LangLayoutAHandleRoute,LangLayoutCategoryCategoryRoute: LangLayoutCategoryCategoryRouteWithChildren,LangLayoutChatTokenRoute: LangLayoutChatTokenRoute,LangLayoutCompareBrandRoute: LangLayoutCompareBrandRoute,LangLayoutErrorStatusRoute: LangLayoutErrorStatusRoute,LangLayoutOrganiserSlugRoute: LangLayoutOrganiserSlugRoute,LangLayoutPlaceCityRoute: LangLayoutPlaceCityRoute,LangLayoutStaysCheckoutRoute: LangLayoutStaysCheckoutRoute,LangLayoutTransportSlugRoute: LangLayoutTransportSlugRoute,LangLayoutBookingsIndexRoute: LangLayoutBookingsIndexRoute,LangLayoutErrorIndexRoute: LangLayoutErrorIndexRoute,LangLayoutExploreIndexRoute: LangLayoutExploreIndexRoute,LangLayoutPlaceIndexRoute: LangLayoutPlaceIndexRoute,LangLayoutStaysIndexRoute: LangLayoutStaysIndexRoute,LangLayoutCityCategorySlugRoute: LangLayoutCityCategorySlugRouteWithChildren,LangLayoutBookingBookingIdThankYouRoute: LangLayoutBookingBookingIdThankYouRoute,LangLayoutExploreCitySlugRoute: LangLayoutExploreCitySlugRoute,LangLayoutStaysBookingReferenceRoute: LangLayoutStaysBookingReferenceRoute,LangLayoutStaysConfirmationReferenceRoute: LangLayoutStaysConfirmationReferenceRoute,LangLayoutStaysReceiptReferenceRoute: LangLayoutStaysReceiptReferenceRoute,LangLayoutCatSlugIndexRoute: LangLayoutCatSlugIndexRoute,LangLayoutExploreCityIndexRoute: LangLayoutExploreCityIndexRoute,LangLayoutStaysCityIndexRoute: LangLayoutStaysCityIndexRoute,LangLayoutStaysCitySlugIndexRoute: LangLayoutStaysCitySlugIndexRoute
}

const LangLayoutRouteWithChildren = LangLayoutRoute._addFileChildren(LangLayoutRouteChildren)




const LangPartnerPartnerRouteChildren = {
  LangPartnerPartnerAccountRoute: LangPartnerPartnerAccountRoute,LangPartnerPartnerHelpRoute: LangPartnerPartnerHelpRoute,LangPartnerPartnerMoneyRoute: LangPartnerPartnerMoneyRoute,LangPartnerPartnerIndexRoute: LangPartnerPartnerIndexRoute,LangPartnerPartnerTripsActivityIdSettingsRoute: LangPartnerPartnerTripsActivityIdSettingsRoute,LangPartnerPartnerTripsActivityIdDatesDateRoute: LangPartnerPartnerTripsActivityIdDatesDateRoute
}

const LangPartnerPartnerRouteWithChildren = LangPartnerPartnerRoute._addFileChildren(LangPartnerPartnerRouteChildren)



const LangPartnerRouteChildren = {
  LangPartnerPartnerRoute: LangPartnerPartnerRouteWithChildren
}

const LangPartnerRouteWithChildren = LangPartnerRoute._addFileChildren(LangPartnerRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,AgafayTarifsRoute: AgafayTarifsRoute,CarouselRoute: CarouselRoute,ConceptRoute: ConceptRoute,DakhlaCarouselRoute: DakhlaCarouselRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,MarrakechCarouselRoute: MarrakechCarouselRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,LangLayoutRoute: LangLayoutRouteWithChildren,LangPartnerRoute: LangPartnerRouteWithChildren,LangLoginRoute: LangLoginRoute,LangSignInRoute: LangSignInRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)